module.exports = __webpack_public_path__ + "img/transform_img.27348b88.svg";